module.exports = __webpack_public_path__ + "img/200-px@2x.03d39e94.png";